import { render, staticRenderFns } from "./editnotelead.vue?vue&type=template&id=3a4cfa7f&"
import script from "./editnotelead.vue?vue&type=script&lang=js&"
export * from "./editnotelead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports